const routes = {
  createUser: 'users',
  getUsers: 'users',
  getUserById: 'users/',
  updateUser: 'users/',
  deleteUser: 'users/',
};

export default routes